export default __webpack_public_path__ + "static/media/policy08_2023.1c06eaca.jpg";